import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import { GET_VENDOR_EXHIBITION_LIST__ACTION_TYPE, MARK_ORDER_SEEN_ACTION_TYPE, GET_EXHIBITION_START_DATE_ACTION_TYPE, getExhibitionStartDateListUrl, markOrderSeenUrl, getVendorExhibitionListListUrl, headers, checkEntryPassExistsUrl, CHECK_ENTRY_PASS_EXISTS_ACTION_TYPE, getVendorExhibitorListUrl, GET_VENDOR_EXHIBITOR_LIST_ACTION_TYPE } from '../../../utils/constants'



export const getVendorExhibitionList_action = (ExhibitionID, ServiceId, StatusID) => async (dispatch) => {

    try {
        const mapdata = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID != '' ? ExhibitionID : null,
            ServiceId: ServiceId != '' ? ServiceId : null,
            StatusID: StatusID != '' ? StatusID : 0,
        }
        console.log("data----------", mapdata)
        const res = await axiosGet(getVendorExhibitionListListUrl, mapdata, headers);

        dispatch({
            type: GET_VENDOR_EXHIBITION_LIST__ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getExhibitionStartDate_action = (ExhibitionID) => async (dispatch) => {

    try {
        const mapdata = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID != '' ? ExhibitionID : null
        }
        console.log("data----------", mapdata)
        const res = await axiosGet(getExhibitionStartDateListUrl, mapdata, headers);

        dispatch({
            type: GET_EXHIBITION_START_DATE_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const checkEntryPassExists_action = (exhRegistrationID) => async (dispatch) => {

    try {
        const finalExhRegID = exhRegistrationID != null && exhRegistrationID != '' && exhRegistrationID != 'null'
            ? exhRegistrationID
            : (sessionStorage.getItem("ExhRegistrationIDSS") == null || sessionStorage.getItem("ExhRegistrationIDSS") == 'null' ? '' : sessionStorage.getItem("ExhRegistrationIDSS"));
        const mapdata = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: JSON.parse(sessionStorage.getItem('sessionExhibitionID')),
            AccountID: JSON.parse(sessionStorage.getItem('loginDataSS')).AccountID,
            ExhRegistrationID: finalExhRegID,
        }
        console.log("data----------", mapdata)
        const res = await axiosGet(checkEntryPassExistsUrl, mapdata, headers);

        dispatch({
            type: CHECK_ENTRY_PASS_EXISTS_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getVendorExhibitorList_action = (ExhibitionID, VendorID, ServiceID) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID != '' ? ExhibitionID : null,
            VendorID: VendorID != '' ? VendorID : 0,
            ServiceID:ServiceID
        }
        console.log("getVendorExhibitorList data----------", mapdata)
        const res = await axiosGet(getVendorExhibitorListUrl, mapdata, headers);

        dispatch({
            type: GET_VENDOR_EXHIBITOR_LIST_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const markOrderSeen_action = (orderDetails) => async (dispatch) => {
    try {
        const params = {
            orderDetails: orderDetails
        }

        const res = await axiosPost(markOrderSeenUrl, params, headers)

        dispatch({
            type: MARK_ORDER_SEEN_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}